import RichText from 'components/UI/Richtext';
import { ReactElement } from 'react';
import { IComponentSimpleHeroTextOnlyFields } from 'types/contentful';

export default function SimpleHeroTextOnly({
  heading,
  copy,
}: IComponentSimpleHeroTextOnlyFields): ReactElement {
  return (
    <div className="ecp-my px-4 w-full relative m-auto md:w-3/4 lg:w-3/5 xl:w-2/4 ">
      <RichText
        document={heading}
        highlight="highlight"
        classNames="text-center text-4xl font-medium italic leading-none font-heading I lg:text-5xl xl:text-5xl"
      />
      <RichText document={copy} classNames="text-center text-base mt-6 lg:text-xl" />
    </div>
  );
}
